import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

export type deleteActivationOrderDataType = {
  id: string;
  successCallback?: Function;
  errorCallback?: Function;
  resultKey?: string;
};

export default ({
  id,
  successCallback,
  errorCallback,
  resultKey = 'deleteActivationOrderData',
}: deleteActivationOrderDataType) =>
  requestAsync({
    url: endpoints.getActivationOrderUrl(id),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: `${endpoints.getActivationOrderUrl(id)}`,
    body: {},
    options: {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      successCallback,
      errorCallback,
      authToken: true,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
